import request from '../request'

// MF-526 — Student summary, auth-scoped to the logged-in student. Returns { student, metrics }:
// `student` is the identity block for the header; `metrics` (attendance / lates / points / gpa) is
// read from the analytics snapshot (DuckDB). The FE decides presentation (labels / tone / chart).
export const getStudentSummary = () =>
  request.get('/dashboard/student-summary').then((res) => res?.data ?? null)
